import React, { useEffect, useState } from 'react';
import { planToMap } from '../../utils/georef';
import { sampleTerrain } from '../../utils/terrain';
import { designElevationAt, pointInPolygon } from '../../utils/grading';

/**
 * ElevationReadout - status bar ground elevation under the cursor, plus the
 * designed pad elevation and cut/fill when the cursor is inside the arena.
 * Subscribes to pointer moves itself so the whole app doesn't re-render.
 */
export const ElevationReadout = ({ cursorListenerRef, screenToWorld, terrain, layer, arenaPoints, grading }) => {
  const [reading, setReading] = useState(null);

  useEffect(() => {
    cursorListenerRef.current = (clientX, clientY) => {
      const world = screenToWorld(clientX, clientY);
      const map = planToMap(layer, world);
      const ground = sampleTerrain(terrain, map.x, map.y);
      if (ground == null) { setReading(null); return; }
      const feetPerUnit = layer.geo.unitsToPlanPx / 40;
      let design = null;
      if (grading && arenaPoints && pointInPolygon(world.x, world.y, arenaPoints)) {
        design = designElevationAt(grading, map.x * feetPerUnit, map.y * feetPerUnit);
      }
      setReading({ ground: ground * feetPerUnit, design });
    };
    return () => { cursorListenerRef.current = null; };
  }, [cursorListenerRef, screenToWorld, terrain, layer, arenaPoints, grading]);

  if (!reading) return null;
  const diff = reading.design == null ? null : reading.ground - reading.design;
  return (
    <span>
      Ground: <span style={{ color: '#00c8ff' }}>{reading.ground.toFixed(2)}'</span>
      {diff != null && (
        <>
          {' '}· Pad: <span style={{ color: '#00c8ff' }}>{reading.design.toFixed(2)}'</span>
          {' '}· <span style={{ color: diff > 0 ? '#ff9a70' : '#70a8ff' }}>
            {diff > 0 ? 'Cut' : 'Fill'} {Math.abs(diff).toFixed(2)}'
          </span>
        </>
      )}
    </span>
  );
};

export default ElevationReadout;
